// wrapper component for svg icons
// this allows an svg to be recoloured using the current text colour
// (similar to font icons)
// Use case: themes with light and dark modes
// IMPORTANT! to be recoloured, the svg must not have fill attributes
//
// Usage: import the SVG as a React component using the ?react suffix
//   import CheckmarkIcon from 'assets/icons/checkmark.svg?react';
//   <SvgIcon icon={CheckmarkIcon} width={16} height={16} />

import { FC, SVGProps } from 'react';
import { SvgIconWrapper } from './SvgIcon.styles';

export type SvgIconProps = {
  icon: FC<SVGProps<SVGSVGElement>>;
  height?: number;
  width?: number;
  className?: string;
};

export const SvgIcon: FC<SvgIconProps> = ({
  icon: Icon,
  height = 24,
  width = 24,
  className,
}) => (
  <SvgIconWrapper
    height={height}
    width={width}
    role='graphics-symbol'
    className={className}
  >
    <Icon aria-hidden='true' width={width} height={height} />
  </SvgIconWrapper>
);
